import React from "react";
// import { useHistory } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CustomButton from "../components/Form/CustomButton";

const ErrorBoundaryPage = ({
  title,
  content,
  onButtonClick,
  buttonLabel,
  includeFooter,
}) => (
  <React.Fragment>
    <Box className="relative md:h-[600px]">
      <img
        src={"SBD/lost2.avif"}
        alt="error"
        className="object-cover h-full w-full hidden md:hidden lg:block"
      />
      <img
        src={"SBD/lost2.avif"}
        alt="error"
        className="object-cover h-fit md:h-[400px] md:w-[100%] w-full block md:block lg:hidden"
      />

      <Box className="absolute items-center top-32 md:top-12 lg:top-32 md:w-full w-[331px] text-center left-0 right-0 md:ml-auto md:mr-auto mx-auto">
        <Typography
          variant="h3"
          color="primary"
          fontSize={{ xs: "38.52px", sm: "60px" }}
          lineHeight={{ xs: "100%", sm: "90.5%" }}
          letterSpacing={"-0.06em"}
          className="capitalize  pt-32"
        >
          {title}
        </Typography>

        <Box className="mb-4">
          <Typography
            variant="body"
            color="primary"
            fontSize={{ xs: "13px", sm: "18px" }}
            lineHeight={{ xs: "185%", sm: "169%" }}
            letterSpacing={{ xs: "0.03em", sm: "0.02em" }}
            className={`-mt-7 md:w-[688px] text-center w-[331px] mx-auto`}
          >
            {content}
          </Typography>
        </Box>

        <CustomButton
          onClick={onButtonClick}
          sx={{ width: "170px", height: "55px" }}
          color="secondary"
          className="text-sm"
          // className="my-9 capitalize text-[12px] leading-[120%] md:leading-[102%] tracking-[0.05em] h-[46px] md:h-[52px] "
        >
          {buttonLabel}
        </CustomButton>
      </Box>
    </Box>

    {/* {includeFooter && <MHFooter />} */}
  </React.Fragment>
);

export default ErrorBoundaryPage;
